import { useCallback, useEffect, useState } from 'react';

const DOWN_ARROW = 40;
const UP_ARROW = 38;

export enum KeyAction {
    Up = 'up',
    Down = 'down',
}
export const DEFAULT_FOCUS_VALUE = -1;

export const useRoveFocus = (size: number, rovingEnabled = true, element: any, initialFocus?: number) => {
    const [currentFocus, setCurrentFocus] = useState(
        initialFocus !== undefined && initialFocus !== -1 ? initialFocus : DEFAULT_FOCUS_VALUE,
    );

    const handleKeyDown = useCallback(
        (e: any) => {
            const getRovingValue = (action: KeyAction) => {
                const value = action === KeyAction.Down ? 0 : size - 1;
                return rovingEnabled ? value : currentFocus;
            };
            if (e.keyCode === DOWN_ARROW) {
                e.preventDefault();
                setCurrentFocus(currentFocus === size - 1 ? getRovingValue(KeyAction.Down) : currentFocus + 1);
            } else if (e.keyCode === UP_ARROW) {
                e.preventDefault();
                setCurrentFocus(currentFocus === 0 ? getRovingValue(KeyAction.Up) : currentFocus - 1);
            }
        },
        [currentFocus, rovingEnabled, size],
    );

    useEffect(() => {
        element.current?.addEventListener('keydown', handleKeyDown, false);
        return () => {
            element.current?.removeEventListener('keydown', handleKeyDown, false);
        };
    }, [element, handleKeyDown]);

    return [currentFocus, setCurrentFocus] as const;
};
